import type { ChargingDetails } from '#domain/ChargingDetails.ts';

import type { ApiChargingDetails, ApiUpdateStop, ApiWriteStop } from '../model/types.ts';

export const mapCharging = (charging?: ApiChargingDetails): ChargingDetails | undefined =>
    charging
        ? {
              configuration: charging.configuration,
              source: charging.source,
              estimate: charging.estimate,
          }
        : undefined;

export const mapChargingToWrite = (charging?: ChargingDetails): ApiWriteStop['charging'] =>
    charging
        ? {
              configuration: charging.configuration,
              source: charging.source,
              estimate: charging.estimate,
          }
        : undefined;

export const mapChargingToUpdate = (charging?: ChargingDetails): ApiUpdateStop['charging'] =>
    charging ? { configuration: charging.configuration, source: charging.source } : undefined;
